export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              type:'Container', 
              name: "Container Marketing",
              attributes: { class: 'container-cubo' },
              components: [
                {
                  type: 'columnsMarketing1', 
                },
                
              ],
              styles: `
             .container-cubo{
                max-width: 1600px; 
             }
            `,
             },
          },
          view: {
      
          },
};
  return component; 
};